import { render } from "./GroupNode.vue?vue&type=template&id=655a4e30"
import script from "./GroupNode.vue?vue&type=script&lang=js"
export * from "./GroupNode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/flow/agent-designer/nodes/GroupNode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "655a4e30"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('655a4e30', __exports__)) {
    api.reload('655a4e30', __exports__)
  }
  
  module.hot.accept("./GroupNode.vue?vue&type=template&id=655a4e30", () => {
    api.rerender('655a4e30', render)
  })

}


export default __exports__